import { FC, useContext } from "react";
import { AppContext } from "../../App";

export const Navigation:FC = () => {
     const { userInfo } = useContext(AppContext);
    return (
        <nav className="navigation">
            {userInfo?.navigation.map(el =>(<a href={"#"+el[1]} key={el[0]} className="nav-link">{el[0]}</a>))}
      </nav>
    )
}
